var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-content",class:{ expanding: _vm.expanding },style:({ left: _vm.left + 'px' })},[_c('router-view',{staticClass:"page-container",attrs:{"id":"page-container"}}),_c('div',{staticClass:"footer-wrapper"},[_c('xp-footbar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }